<template>
  <cdr-icon style="width: 32px; height: 32px;">
    <!-- Cone body. The stripes are polygons inscribed in the cone rather than
         clipped, so the icon needs no clipPath and therefore no document-wide
         id that could collide with another inline SVG on the page. -->
    <path
      d="M3.1 21.6 7.35 9.85 14.7 17.2 3.1 21.6Z"
      fill="#4caf50"
    />

    <g
      fill="#ffffff"
      fill-opacity=".42"
    >
      <path d="M4.375 18.075 5.14 15.96 8.67 19.49 6.58 20.28Z" />
      <path d="M5.735 14.315 6.5 12.2 12.38 18.08 10.29 18.87Z" />
    </g>

    <path
      d="M7.35 9.85a1.2 1.2 0 0 1 2.02-.5l6.03 6.03a1.2 1.2 0 0 1-.5 2.02L3.1 21.6a1.2 1.2 0 0 1-1.52-1.52L7.35 9.85Z"
      fill="none"
      stroke="#2f3a3d"
      stroke-width="1.9"
      stroke-linejoin="round"
    />

    <g
      fill="none"
      stroke="#2f3a3d"
      stroke-width="1.6"
      stroke-linecap="round"
    >
      <path d="M8.8 9.2C11.2 8 8.2 6.4 10.6 5.2 13 4 10 2.4 12.4 1.2" />
      <path d="M13.6 7.4C16 6.2 13 4.6 15.4 3.4" />
      <path d="M15.9 10.6 17.6 8.9" />
      <path d="M17.6 14.3 20.4 13.2" />
      <path d="M16.9 17.7 18.5 19.3" />
    </g>

    <path
      d="M20.6 3.2 22.5 5.1 20.6 7 18.7 5.1Z"
      fill="#4caf50"
      stroke="#2f3a3d"
      stroke-width="1.6"
      stroke-linejoin="round"
    />
  </cdr-icon>
</template>

<script setup lang="ts">
import { CdrIcon } from '@rei/cedar';
</script>
